module.exports = __webpack_public_path__ + "static/old-man-a09e1612bbe3e28fba64261639c1bde0.jpeg";